// import moment from "moment";
import dayjs from "dayjs";

import relativeTime from "dayjs/plugin/relativeTime";
import utcExtend from "dayjs/plugin/utc";

import parseZoneExtend from "./dayjsJsPluginFunc";
dayjs.extend(parseZoneExtend);
dayjs.extend(utcExtend);
dayjs.extend(relativeTime);

function add(numberDuration, typeDuration) {
  this._date = this._date.add(numberDuration, typeDuration);
  return this._date;
}

function subtract(numberDuration, typeDuration) {
  this._date = this._date.subtract(numberDuration, typeDuration);
  return this._date;
}

function diff(targetDate, differenceType) {
  return this._date.diff(targetDate._date, differenceType);
}

function fromNow(suffix = false) {
  this._date = this._date.fromNow(suffix);
  return this._date;
}

function utc() {
  this._date = this._date.utc();
  return this._date;
}

function get(unit) {
  return this._date.get(unit);
}

function format(outputFormat) {
  return this._date.format(outputFormat);
}

function startOf(type) {
  return this._date.startOf(type);
}

function endOf(type) {
  return this._date.endOf(type);
}

function toISOString(value = true) {
  if (value) {
    this._date = this._date.format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  } else {
    this._date = this._date.toISOString();
  }
  return this._date;
}

function toString() {
  return this._date.toString();
}

function isBefore(value) {
  return this._date.isBefore(value);
}

function isAfter(value) {
  return this._date.isAfter(value);
}

function isSame(value, unit = null) {
  return this._date.isSame(value, unit);
}

function set(unit, value) {
  this._date = this._date.set(unit, value);
  return this._date;
}

function utcOffset(input = null) {
  return this._date.utcOffset(input);
}

function parseZone(value, format) {
  return dayjs.parseZone(value, format);
}

const DateLib = (input = new Date(), inputFormat = "") => {
  return Object.create(DateLib.prototype, {
    _date: {
      // value: moment(input, inputFormat),
      value: dayjs(input, inputFormat),
      writable: true,
      enumerable: true,
      configurable: true,
    },
  });
};

DateLib.prototype = {
  constructor: DateLib,
  add,
  subtract,
  format,
  diff,
  utc,
  get,
  fromNow,
  startOf,
  endOf,
  toISOString,
  isBefore,
  isAfter,
  isSame,
  set,
  utcOffset,
  parseZone,
};

export default DateLib;